import { render, staticRenderFns } from "./CbsBudreqFinance.vue?vue&type=template&id=fccbed3a&scoped=true"
import script from "./CbsBudreqFinance.vue?vue&type=script&lang=js"
export * from "./CbsBudreqFinance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fccbed3a",
  null
  
)

export default component.exports